module.exports = __webpack_public_path__ + "b8bcb68d9374e9a0f122f381b10afb2d.pdf";